exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.signs-description[data-v-12668168] {\n    display: inline-block;\n    padding: 5px 10px;\n}\n.links[data-v-12668168]:hover {\n    cursor: pointer;\n}\nspan[data-v-12668168] .dot {\n    display: inline-block;\n    width: 1em;\n    height: 1em;\n    border-radius: 50%;\n}\n", ""]);

